import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react'
import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultWallets,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import {
  chain,
  configureChains,
  createClient,
  WagmiConfig,
  useContractReads
} from 'wagmi';
import { arbitrumNova } from '@wagmi/chains';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'

const { chains, provider } = configureChains(
  [
    // // chain.mainnet
    // chain.polygon,
    // chain.goerli
    // chain.optimism
    // chain.arbitrum
    arbitrumNova
    // arbitrumNova
  ],
  [
    // alchemyProvider({ apiKey: 't5FoywbZsfP167tfrs1_LYm02ezBBAOk' }), // polygon
    // alchemyProvider({ apiKey: 'Aw379YNw_95SbDzsfdSkUdhIMdMPyQuI' }), // goerli
    // alchemyProvider({ apiKey: 'PM0TA30rzEILWFGqkp3AzmrfaeWC7wxk' }), // mainnet
    //alchemyProvider({ apiKey: 'njQM4Y16n4yyglo_D8aIJFYbmUtohciQ' }), // optimism
    // jsonRpcProvider({rpc: (chain) => ({http: `https://${chain.id}.example.com`,}),}), // JSON RPC Example

jsonRpcProvider({rpc: (chain) => ({http: `https://open-platform.nodereal.io/a31b73a77fbd43f08199ba866b01f7b9/arbitrum/`,}),stallTimeout: 1000,}),
jsonRpcProvider({rpc: (chain) => ({http: `https://arbitrum-nova.blockpi.network/v1/rpc/public`,}),stallTimeout: 1000,}),
jsonRpcProvider({rpc: (chain) => ({http: `https://arbitrum-nova.publicnode.com`,}),stallTimeout: 1000,}),
jsonRpcProvider({rpc: (chain) => ({http: `https://arbitrum-nova.public.blastapi.io`,}),stallTimeout: 1000,}),
jsonRpcProvider({rpc: (chain) => ({http: `https://nova.arbitrum.io/rpc`,}),stallTimeout: 1000,}),
jsonRpcProvider({rpc: (chain) => ({http: `https://rpc.ankr.com/arbitrumnova`,}),stallTimeout: 1000,}),

    // publicProvider()
  ]
);

const { connectors } = getDefaultWallets({
  appName: 'PEPE',
  chains
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <WagmiConfig client={wagmiClient}>
        <RainbowKitProvider coolMode chains={chains}>
          <App />
        </RainbowKitProvider>
      </WagmiConfig>
    </ChakraProvider>
  </React.StrictMode>
);